import {
    BASE_MODULE_DELETE,
    BASE_MODULE_INSERT,
    BASE_MODULE_UPDATE,
    BASE_MODULES_LIST,
    BASE_MODULES_PAGINATION,
    BASE_MODULES_CACHE_CLEAR,
    BASE_MODULES_CACHE_SET,
} from "./constant";

const initialState = {
    baseModulesList: [],
    pagination: {},
    moduleTypeDropdown: [],

    cache: {},
};

const BaseModulesReducer = (state = initialState, action) => {
    switch (action.type) {
        // ====================================
        // LIST
        // ====================================

        case BASE_MODULES_LIST:
            return {
                ...state,
                baseModulesList: action.payload,
            };

        // ====================================
        // PAGINATION
        // ====================================

        case BASE_MODULES_PAGINATION:
            return {
                ...state,
                pagination: action.payload,
            };

        // ====================================
        // INSERT DATA
        // ====================================

        case BASE_MODULE_INSERT:
            return {
                ...state,
                baseModulesList: [action.payload, ...state.baseModulesList],
            };

        // ====================================
        // UPDATE DATA
        // ====================================

        case BASE_MODULE_UPDATE:
            return {
                ...state,
                baseModulesList: state.baseModulesList.map((item) =>
                    item.BASEMODULE_ID === action.payload?.BASEMODULE_ID
                        ? action.payload
                        : item,
                ),
            };

        // ====================================
        // DELETE DATA
        // ====================================

        case BASE_MODULE_DELETE:
            return {
                ...state,
                baseModulesList: state.baseModulesList.filter(
                    (item) => item.BASEMODULE_ID !== action.payload,
                ),
            };

        case "SET_BASE_MODULE_TYPES":
            return {
                ...state,
                moduleTypeDropdown: action.payload,
            };

        case BASE_MODULES_CACHE_SET:
            return {
                ...state,
                cache: {
                    ...state.cache,
                    [action.payload.cacheKey]: {
                        data: action.payload.data,
                        pagination: action.payload.pagination,
                        timestamp: action.payload.timestamp,
                    },
                },
            };

        case BASE_MODULES_CACHE_CLEAR:
            return {
                ...state,
                cache: {},
            };

        default:
            return state;
    }
};

export default BaseModulesReducer;
